import { useContext } from "react";
import { motion } from "framer-motion";
import { Check, Info } from "lucide-react";
import { LanguageContext } from "../App";

export default function HotelDetails() {
  const { t } = useContext(LanguageContext);
  const d = t.hotel_details;

  return (
    <section
      data-testid="hotel-details-section"
      className="bg-[#FDFBF7] py-16 md:py-20 px-6"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10 max-w-2xl">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="font-['Manrope',sans-serif] text-xs uppercase tracking-[0.3em] text-[#7B907F] mb-3"
          >
            {d.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-['Cormorant_Garamond',serif] text-2xl sm:text-3xl md:text-4xl font-light text-[#2A2726] tracking-tight"
          >
            {d.headline}
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
          {/* Qualità */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8 }}
            className="flex flex-col gap-4"
          >
            {d.qualities.map((q, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                  <Check size={15} strokeWidth={2.5} className="text-[#7B907F]" />
                </div>
                <p className="font-['Manrope',sans-serif] text-sm text-[#5C5754] leading-relaxed">
                  {q}
                </p>
              </div>
            ))}
          </motion.div>

          {/* Note importanti */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="flex flex-col gap-4"
          >
            <p className="font-['Manrope',sans-serif] text-xs uppercase tracking-[0.2em] text-[#8A847F] mb-1">
              {d.notes_title}
            </p>
            {d.notes.map((n, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                  <Info size={14} strokeWidth={2} className="text-[#8A847F]" />
                </div>
                <p className="font-['Manrope',sans-serif] text-sm text-[#8A847F] leading-relaxed">
                  {n}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
